import { MaRechercheSection } from '../components/dashboard/MaRechercheSection';

export default function RecherchePage() {
    return (
        <div className="p-4 md:p-6 lg:p-8" data-testid="recherche-page">
            <div className="mb-6">
                <h1
                    className="text-2xl md:text-3xl font-bold text-slate-900 tracking-tight"
                    style={{ fontFamily: 'Manrope, sans-serif' }}
                >
                    Ma recherche
                </h1>
                <p className="mt-1 text-sm text-slate-500">
                    Cherchez par nom, téléphone ou n° de devis — les résultats s'affichent par module.
                </p>
            </div>
            <MaRechercheSection autoFocus />
        </div>
    );
}
